import SkipToContentAction from "../actions/skipToContentAction";
import ClearSkipToContentAction from "../actions/clearSkipToContentAction";
import objectPath from 'object-path'


export default function reduce(state = {}, action)
{
    switch(action.type)
    {
        case SkipToContentAction.name:
        case ClearSkipToContentAction.name:
            objectPath.set(state, action.payload.stateLocation, action.payload.value);
            return state;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-skip-to-content/src/reducers/index.js